<template>
  <div class="">
    <div class="row mb-1">
      <div class="col-md-8">
        <h4 class="text-uppercase mt-1" :class="{'d-none':hideProducts}">
          {{ lexicon.drop_new_order }}
        </h4>

      </div>
    </div>

    <section id="groups">

      <div class="row mb-3" v-if="!loading" :class="{'d-none1':hideProducts}">
        <div class="col-lg-7 col-md-12 card-deck1">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <div class="d-flex justify-content-between">
                  <h4 class="mb-2">
                    {{ lexicon.drop_order_info }}
                  </h4>
                  <div class="d-inline-block w-50 text-right">
                    <div class="custom-control custom-switch custom-switch-success mr-2 mb-01">
                      <input type="checkbox" id="switch_product" class="custom-control-input" v-model="order.customTTN">
                      <label for="switch_product" class="custom-control-label">
                        <span class="switch-icon-left">
                          <i class="feather icon-check"></i>
                        </span>
                        <span class="switch-icon-right">
                          <i class="feather icon-check"></i>
                        </span>
                      </label>
                      <small class="d-inline-block ml-1 ">Своя ТТН</small>
                    </div>
                  </div>
                </div>
                <div class="alert" v-if="user.alert.text" :class="user.alert.class"
                     v-html="user.alert.text"></div>
                <div v-if="user.admin">
                  <div class="form-body">
                    <fieldset class="form-group">
                      <label>{{ lexicon.drop_select_customer }}</label>
                      <UserAutocomplete @input="changeUser" v-if="users.length"
                                        :placeholder="lexicon.drop_select_customer"
                                        :items="users"
                      />
                    </fieldset>
                  </div>

                </div>

                <form action="" @change="validateForm" @submit.prevent="createOrder">
                  <div class="form-body" v-if="!order.customTTN">
                    <div class="row">
                      <div class="col-md-6 col-12">
                        <fieldset class="form-group">
                          <label>{{ lexicon.drop_customer_fullname }}</label>
                          <div class="position-relative">
                            <input type="text" class="form-control" required
                                 :class="{error:error.name}"
                                 v-model="order.name"
                                 @input.passive="validateInput($event,'name')"
                                 :placeholder="lexicon.drop_customer_fullname">
                          <div class="form-control-position clear-input" @click="order.name = '';validateForm();">
                            <i class="feather icon-delete " v-if="order.name.length"></i>
                          </div>
                          </div>
                        </fieldset>
                      </div>
                      <div class="col-md-6 col-12">
                        <fieldset class="form-group">
                          <label>{{ lexicon.drop_customer_phone }}</label>
                              <div class="position-relative">
                          <input type="tel" class="form-control" required
                                 :class="{error:error.phone}"
                                 v-model="order.phone"
                                 @input.passive="validateInput($event,'phone')"
                                 :placeholder="lexicon.drop_customer_phone">
                           <div class="form-control-position clear-input" @click="order.phone =  '';validateForm();">
                            <i class="feather icon-delete " v-if="order.phone.length"></i>
                          </div>
                              </div>
                        </fieldset>
                      </div>

                      <!--                      <pre class="col-12"> {{ delivery }} {{ error }}</pre>-->
                      <!--                      <div class="col-md-6 col-12 ">-->
                      <!--                        <fieldset class="form-group">-->
                      <!--                          <label>{{ lexicon.drop_country }}</label>-->

                      <!--                          <select class="custom-select d-block w-100" required-->
                      <!--                                  :class="{error:error.country}" v-model="delivery.country">-->

                      <!--                            <option :value="country_item" :key="country_item" v-for="(item,country_item) in countries">-->
                      <!--                              {{ lexicon['drop_coutry_' + country_item] }}-->
                      <!--                            </option>-->
                      <!--                          </select>-->
                      <!--                          &lt;!&ndash;                                                  {{countries}}&ndash;&gt;-->
                      <!--                        </fieldset>-->
                      <!--                      </div>-->
                      <div class="col-md-6 col-12 ">
                        <fieldset class="form-group" v-if=" countries[delivery.country]">
                          <label>{{ lexicon.drop_post_service }}</label>
                          <select class="custom-select d-block w-100" required :class="{error:error.post_type}"
                                  v-model="delivery.method">
                            <option :value="item" v-for="(type,item) in countries[delivery.country]" :key="item">
                              {{ lexicon['drop_delivery_' + item] }}
                            </option>
                          </select>
                        </fieldset>
                      </div>
                      <template v-if="delivery.type === 'address'">
                        <!--                        <div class="col-md-4 col-12">-->
                        <!--                          <fieldset class="form-group">-->
                        <!--                            <label>{{ lexicon.drop_zip }}</label>-->
                        <!--                            <input type="text" class="form-control" required-->
                        <!--                                   :class="{error:error.zip}"-->
                        <!--                                   v-model="delivery.zip"-->
                        <!--                                   :placeholder="lexicon.drop_zip">-->
                        <!--                          </fieldset>-->
                        <!--                        </div>-->
                        <div class="col-md-6 col-12">
                          <fieldset class="form-group">
                            <label>{{ lexicon.drop_customer_city }}</label>
                            <autocomplete :select="{name:order.city}" @input="changeCity"
                                          v-if="city.length" :disabled="city.length <1"
                                          :placeholder="lexicon.drop_customer_city"
                                          :error="error.city"

                                          key="cityNp"
                                          :items="city"
                            />
                            <!--                            <input type="text" class="form-control" required-->
                            <!--                                   :class="{error:error.city}"-->
                            <!--                                   v-model="delivery.city"-->
                            <!--                                   :placeholder="lexicon.drop_customer_city">-->
                          </fieldset>
                        </div>
                        <div class="col-md-8 col-12">
                          <fieldset class="form-group">
                            <label>{{ lexicon.drop_street }}</label>
                            <input type="text" class="form-control" required
                                   :class="{error:error.street}"
                                   v-model="delivery.street"
                                   :placeholder="lexicon.drop_street">
                          </fieldset>
                        </div>
                        <div class="col-md-4 col-12">
                          <fieldset class="form-group">
                            <label>{{ lexicon.drop_house }}</label>
                            <input type="text" class="form-control" required
                                   :class="{error:error.house}"
                                   v-model="delivery.house"
                                   :placeholder="lexicon.drop_house">
                          </fieldset>
                        </div>

                      </template>
                      <template v-if="delivery.type === 'up'">
                        <!--                        <div class="col-md-6 col-12">-->
                        <!--                          <fieldset class="form-group">-->
                        <!--                            <label>{{ lexicon.drop_customer_city }}</label>-->
                        <!--                            <autocomplete :select="{name:order.city}" @input="changeCity"-->
                        <!--                                          :is-async="true"-->
                        <!--                                          :placeholder="lexicon.drop_customer_city"-->
                        <!--                                          :error="error.city"-->
                        <!--                                          key="cityUp"-->
                        <!--                                          :items="cityUp"-->
                        <!--                                          @change="loadUp"-->
                        <!--                            />-->
                        <!--                          </fieldset>-->
                        <!--                        </div>-->
                        <!--                        <div class="col-md-6 col-12">-->
                        <!--                          <fieldset class="form-group">-->
                        <!--                            <label>{{ lexicon.drop_customer_branch }}</label>-->
                        <!--                            <autocomplete :select="{name:order.sklad}" :error="error.sklad"-->
                        <!--                                          :items="sklad" @input="changeNP"-->
                        <!--                                          key="skladUp"-->
                        <!--                                          :disabled="(sklad.length <1)"-->
                        <!--                                          :placeholder="lexicon.drop_customer_branch"-->
                        <!--                            />-->
                        <!--                          </fieldset>-->
                        <!--                        </div>-->
                        <div class="col-md-6 col-12">
                          <fieldset class="form-group">
                            <label>{{ lexicon.drop_zip }}</label>
                            <!--                            <input type="tel" class="form-control" required-->
                            <!--                                   :class="{error:error.sklad}"-->
                            <!--                                   v-model="order.sklad_ref"-->
                            <!--                                   :placeholder="lexicon.drop_zip">-->

                            <autocomplete :select="{name:order.sklad_ref}"
                                          @input="setZip"
                                          @change="searchZip"
                                          :placeholder="lexicon.drop_zip"
                                          :error="error.sklad_ref"
                                          :isAsync="true"
                                          key="skladUP"
                                          :items="sklad"
                            />
                          </fieldset>
                        </div>
                      </template>
                      <template v-if="delivery.type === 'inpost'">
                        <div class="col-12">
                          inpost
                        </div>
                      </template>
                      <template v-if="delivery.type === 'np'">
                        <div class="col-md-6 col-12">
                          <fieldset class="form-group">
                            <label>{{ lexicon.drop_customer_city }}</label>
                            <autocomplete :select="{name:order.city}" @input="changeCity"
                                          v-if="city.length" :disabled="city.length <1"
                                          :placeholder="lexicon.drop_customer_city"
                                          :error="error.city"

                                          key="cityNp"
                                          :items="city"
                            />
                          </fieldset>
                        </div>
                        <div class="col-md-6 col-12">
                          <fieldset class="form-group">
                            <label>{{ lexicon.drop_customer_branch }}</label>
                            <autocomplete :select="{name:order.sklad}" :error="error.sklad"
                                          :items="sklad" @input="changeNP"
                                          :disabled="(sklad.length <1)"
                                          key="skladNp"
                                          :placeholder="lexicon.drop_customer_branch"
                            />
                          </fieldset>
                        </div>
                      </template>

                      <div class="col-md-6 col-12">
                        <fieldset class="form-group">
                          <label>{{ lexicon.drop_delivery_payer }}</label>
                          <select class="custom-select d-block w-100" required
                                  :class="{error:error.pay_del}"
                                  v-model="order.pay_del">
                            <option value="1">{{ lexicon.drop_receiver }}</option>
                            <option value="2">{{ lexicon.drop_sender }}</option>
                          </select>
                        </fieldset>
                      </div>
                      <div class="col-md-6 col-12">
                        <fieldset class="form-group">
                          <label>{{ lexicon.drop_afterpay }}</label>
                          <select class="custom-select d-block w-100" required :disabled="delivery.method === 'up'"
                                  :class="{error:error.nal_type}"
                                  v-model="order.nal_type">
                            <option value="1">{{ lexicon.drop_no }}</option>
                            <option value="2">{{ lexicon.drop_yes }}</option>
                          </select>
                        </fieldset>
                      </div>
                      <template v-if="order.nal_type == 2">
                        <div class="col-md-6 col-12">
                          <fieldset class="form-group">
                            <label>{{ lexicon.drop_afterpay_sum }}</label>
                            <div class="input-group">
                              <input type="number" min="0" step="1" class="form-control"
                                     required
                                     :class="{error:error.nal}"
                                     v-model="order.nal">
                              <div class="input-group-append">
                                                                <span class="input-group-text">{{
                                                                    lexicon[user.currency]
                                                                  }}.</span>
                              </div>
                            </div>
                          </fieldset>
                        </div>
                        <div class="col-md-6 col-12">
                          <fieldset class="form-group">
                            <label>{{ lexicon.drop_af_payer }}</label>
                            <select class="custom-select d-block w-100" required
                                    :class="{error:error.pay_redel}"
                                    v-model="order.pay_redel">
                              <option value="1">{{ lexicon.drop_receiver }}</option>
                              <option value="2">{{ lexicon.drop_sender }}</option>
                            </select>
                          </fieldset>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="form-body" v-else>
                    <div class="row">
                      <div class="col-12 text-center mb-2 " :class="{'d-none':order.ttn !==''}">
                        <h6 v-html="lexicon.drop_custom_ttn_title"></h6>
                        <label for="customTTNFileInput"
                               class="customTTNFileWrap d-block py-3 rounded rounded-2 position-relative cursor-pointer">
                          <input type="file" accept=".pdf" id="customTTNFileInput" @change.prevent="onTTNUpload($event)"
                                 ref="cTTN">
                          <span class="text-primary"> Перетягніть файл в цю область або натисніть для вибору</span>
                        </label>
                      </div>
                      <div class="col-12" v-if="order.ttn !=='' ">
                        <table class="table table-striped">
                          <tbody>
                          <tr>
                            <td>ТТН</td>
                            <td class="text-justify">
                              {{ order.ttn }}
                              <button class=" float-right btn btn-warning btn-sm" type="button"
                                      @click.prevent="order.ttn=''"><i class="feather icon-trash-2"></i> Очистити
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>Місто</td>
                            <td>{{ order.customTTN.city }}</td>
                          </tr>
                          <tr>
                            <td>Відділення</td>
                            <td>{{ order.customTTN.sklad }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="form-body">
                    <div class="row">
                      <div class="col-12">
                        <button type="submit" :disabled="hasError"
                                class="btn btn-primary mr-1 mb-1 waves-effect waves-light btn-block">
                          {{ lexicon.drop_create_order }}
                        </button>
                      </div>
                    </div>
                    <div class="alert alert-dark" v-if="user.alert_bottom.text"
                         :class="user.alert_bottom.class"
                         v-html="user.alert_bottom.text">
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-sm-12 card-deck1">
          <div class="card">
            <div class="card-content">
              <div class="card-body">

                <div class="orderCart">
                  <h4 class="mb-2">
                    {{ lexicon.drop_cart_title }}
                    <span class="badge badge-primary badge-pill float-right cart_count"
                          v-if="totalCount">{{ totalCount }}</span>
                  </h4>
                  <div class="alert alert-danger" v-if="errorProducts.length">
                    <p class="card-text">
                      {{ lexicon.drop_err_cunt }}
                    </p>
                    <ul class="text-dark list-unstyled">
                      <li v-for="product in errorProducts" :key="product.id">
                        {{ product.article }} -
                        <span class=" text-bold-600">{{
                            product.stock
                          }} {{ lexicon.drop_opt_cnt_unit }}</span>
                      </li>
                    </ul>
                  </div>
                  <div class="text-center h5" v-if="!cart.length">
                    {{ lexicon.drop_cart_is_empty }}
                  </div>
                  <div v-else>
                    <div class="row">
                      <div class="cart-item col-sm-6 " v-for="(product,kkey) in cart"
                           :key="product.id">
                        <div class="product-content p-1  border mb-1 rounded">
                          <div class="col-12w">
                            <img :src="product.image"
                                 class="w-100 img-thumbnail float-left mr-1">

                            <div class="product-content-right">
															<span class="text-primary">
															{{ product.article }}
														</span>

                              <div
                                  class="text-success h4 my-50 text-nowrap ">{{
                                  (product.count * product.price).toFixed(2)
                                }}&nbsp;{{ lexicon[user.currency] }}

                              </div>

                              <div class="input-group d-inline-flex w-auto">
                                <div class="input-group-prepend">
                                  <button class="btn btn-primary p-50"
                                          type="button" :disabled="product.count<2"
                                          @click="decrementItemQuantity(product)">
                                    -
                                  </button>
                                </div>
                                <input type="text"
                                       class="form-control py-25 text-center"
                                       v-model="product.count"
                                       readonly
                                >
                                <div class="input-group-append">
                                  <button class="btn btn-primary p-50"
                                          @click="addProductToCart(product)"
                                          type="button">+
                                  </button>
                                </div>

                              </div>

                              <div v-if="product.custom" class="my-1">
                                <span v-for="(file,key) in product.files" :key="file">
                                  <a :href="file" class="" target="_blank">
                                    <i class="feather icon-file"></i> {{ key + 1 }}
                                  </a>
                                </span>
                                <br>

                              </div>

                            </div>
                            <button class="btn btn-sm px-50 btn-remove-product"
                                    :title="lexicon.drop_btn_remove"
                                    @click="removeProductFromCart(product)">
                              <i class="feather icon-trash-2 font-medium-1"></i>
                            </button>
                            <div class="clearfix"></div>
                            <small class="oneline">{{ product.name }}</small>
                            <label :for="'customTTNFileInput'+kkey" v-if="product.custom"
                                   class="customTTNFileWrap d-block w-100 py-3 rounded rounded-2 position-relative cursor-pointer text-center">
                              <input type="file" :id="'customTTNFileInput'+kkey" class="customTTNFileInput"
                                     @change.prevent="onTTNUploadCart($event,product)"
                                     ref="cTTN">
                              <span class="text-primary"> Перетягніть файл в цю область або натисніть для вибору</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--
                    <div class="cart-item py-1 border-bottom" v-for="product in cart"
                                            :key="product.id">
                                          <div class="row ">
                                            <div class="col-sm-8">
                                              <img :src="product.image"
                                                  class="w-100 img-thumbnail float-left mr-1">
                                              {{product.name}}
                                              <br>
                                              <small class="text-primary">
                                                {{product.article}}
                                              </small>
                                              <br>
                                              <div class="input-group quantity-counter-wrapper bootstrap-touchspin">
                                                <span class="input-group-btn input-group-prepend bootstrap-touchspin-injected">
                                                  <button @click="decrementItemQuantity(product)"
                                                      class="btn btn-primary bootstrap-touchspin-down"
                                                      type="button" :disabled="product.count<2">-</button>
                                                </span>
                                                <input type="text" readonly
                                                    class="quantity-counter form-control"
                                                    v-model="product.count">
                                                <span class="input-group-btn input-group-append bootstrap-touchspin-injected">
                                                  <button @click="addProductToCart(product)"
                                                      class="btn btn-primary bootstrap-touchspin-up"
                                                      type="button">+</button>
                                                </span>
                                              </div>
                                            </div>
                                            <div class="col-sm-4 align-self-center">
                                              <div class="d-flex justify-content-between  ">
                                                <span class="text-success h4 pt-50 text-nowrap ">{{(product.count * product.price).toFixed(2)}}&nbsp;$</span>
                                                <span>
                                                  <button class="btn btn-outline-danger btn-sm"
                                                      @click="removeProductFromCart(product)">
                                                    <i class="feather icon-trash font-medium-1"></i>
                                                  </button>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                    -->
                  </div>
                  <div class="mt-2" v-if="totalCount">
                    <ul class="list-group mb-3">
                      <li class="list-group-item d-flex justify-content-between " id="forDel">
                        <span class="text-danger">{{ lexicon.drop_delivery }}</span>
                        <strong class="text-danger h4">
                          {{ deliveryCost.toFixed(2) }}{{ lexicon[user.currency] }}
                        </strong>
                      </li>
                      <li class="list-group-item d-flex justify-content-between " id="forDsic" v-if="discount > 0">
                        <span class="text-info">{{ lexicon.drop_discount }}</span>
                        <strong class="text-info h4">
                          -{{ discount.toFixed(2) }}{{ lexicon[user.currency] }}
                        </strong>
                      </li>
                      <li class="list-group-item d-flex justify-content-between">
                        <span class="text-success">{{ lexicon.drop_cart_total }}</span>
                        <strong class="text-success h4">
                          {{ (deliveryCost + totalCost - discount).toFixed(2) }}
                          {{ lexicon[user.currency] }}
                        </strong>
                      </li>
                    </ul>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="pb-3" v-if="showProductsAreaBtn && !loading">
        <button class="btn btn-primary btn-block" @click="showProductsArea = !showProductsArea">
                   <span v-if="!showProductsArea">
                       Показати
                   </span>
          <span v-if="showProductsArea">
                       Приховати
                   </span>
          товари
        </button>
      </div>
      <div id="products" v-if="showProductsArea">
        <div class="row" v-if="!loading">
          <div class="col-md-12">
            <div class="card">
              <div class="card-content">
                <div class="card-body">
                  <h4 class="mb-2">
                    {{ lexicon.drop_products }}
                  </h4>
                  <div class="row">
                    <div class="col-sm-12  " :class="{'col-md-8':!hasCustom,'col-md-7':hasCustom}">
                      <fieldset class="form-group position-relative">
                        <input type="text" class="form-control search-product" id="iconLeft5"
                               :placeholder="lexicon.drop_search_input" v-model="search">
                        <div class="form-control-position">
                          <i class="feather icon-search"></i>
                        </div>
                      </fieldset>
                    </div>
                    <div :class="{'col-sm-12 col-md-4':!hasCustom,'col-sm-8 col-md-4':hasCustom}">
                      <fieldset class="form-group position-relative">
                        <select v-model="ptype" class="form-control  ptype-filter">
                          <option :value="val" v-for="(lx,val) in categories" :key="lx">{{ lexicon[lx] }}</option>
                        </select>
                      </fieldset>
                    </div>
                    <div class="col-sm-4 col-md-1" :class="{'d-none':!hasCustom}">

                      <button class="btn btn-success btn-block btn-lg ptype-filter px-3" type="button"
                              @click.prevent="showCustomModal"
                              aria-expanded="false">
                        <i class="feather icon-image"></i>
                      </button>
                    </div>
                  </div>
                  <div class="col-12">
                    <!--                    <Product :product="product"  v-for="product in filteredProducts" @addProductToCart="addProductToCart" :key="product.id" />-->
                    <InfiniteScroll :items="filteredProducts" @addProductToCart="addProductToCart"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <template v-else>
          <div class="text-center">
            <div class="spinner-border text-primary my-5" role="status">
              <span class="sr-only">{{ lexicon.drop_loading }}</span>
            </div>
          </div>
        </template>
      </div>
    </section>

  </div>
</template>

<script>

import axios from "axios";
import {mapActions, mapGetters, mapState} from 'vuex'
import autocomplete from '../components/Autocomplete.vue';
import UserAutocomplete from '../components/UserAutocomplete'
// import Product from '../components/Product'
import InfiniteScroll from '../components/InfiniteScroll'

export default {
  name: 'create-order',
  components: {
    autocomplete,
    // Product,
    InfiniteScroll,
    UserAutocomplete,
  },
  data() {
    return {
      selectedCity: {},
      loading: true,
      showProductsArea: true,
      showProductsAreaBtn: false,
      showDD: false,
      hideProducts: false,
      hasError: true,
      errorProducts: {},
      users: [],
      search: "",
      cTTNFile: null,
      deliveryCost: 0,
      discount: 0,
      ptype: "",
      countries: {
        'ukraine': {
          'np': 'np',
          'up': 'up',
          'np_address': 'address',
        },
        // 'poland': {
        //   'inpost_p': 'inpost',
        //   'inpost': 'address',
        //   'gls': 'address',
        //   'dpd': 'address',
        // },
        // 'germany': {
        //   'gls': 'address',
        //   'dpd': 'address',
        //   'dhl': 'address',
        // },
      },
      order: {
        city_ref: "",
        user_id: 0,
        sklad_ref: "",
        name: "",
        phone: "",
        city: "",
        sklad: "",
        pay_del: 1,
        nal_type: 1,
        post_type: 'np',
        nal: 0,
        pay_redel: 1,
        customTTN: false,
        ttn: '',
        customTTNData: {},
      },
      delivery: {
        type: '',
        method: '',
        country: '',
        city: '',
        city_ref: '',
        sklad: '',
        sklad_ref: '',
        zip: '',
        street: '',
        house: '',
      },
      error: {
        name: false,
        phone: false,
        city: false,
        sklad: false,
        pay_del: false,
        nal_type: false,
        nal: false,
        pay_redel: false,
        country: false,
      },
      city: [],
      cityUp: [],
      sklad: [],
    }
  },
  computed: {
    ...mapGetters({
      cart: 'cart/cartProducts',
      user: 'auth/user',
      totalCost: 'cart/cartTotalPrice',
      totalCount: 'cart/cartTotalCount',
      addBtn: 'cart/addBtn',
      updateDisc: 'cart/updateDisc',
      // products: 'products/all',
      // authenticated: 'auth/authenticated',
    }),
    ...mapState({
      products: state => state.products.all,
      custom: state => state.products.custom,
      categories: state => state.products.categories,
      lexicon: state => state.lexicon
    }),
    filteredProducts() {
      const search = this.search.toLowerCase().trim();
      if (!search && this.ptype === '') return this.products;
      return this.products.filter(c => ((c.name.toLowerCase().indexOf(search) > -1 || c.article.toLowerCase().indexOf(search) > -1) && (c.ptype === this.ptype || this.ptype === '')));
    },
    hasCustom() {
      return Object.entries(this.custom).length > 100
    }
  },
  created() {
    this.fetchData()
    this.npData('city', '')
    if (this.user.settings.hide_products) {
      this.showProductsArea = false
      this.showProductsAreaBtn = true
    }
    if (this.user.admin) {
      this.usersData()
    }

  },
  watch: {
    $route: 'fetchData',
    totalCost: 'validateForm',
    addBtn: function () {
      this.hideProducts = false
    },
    updateDisc: function (value) {
      if (value) {
        this.updateDiscount()
      }
    },
    'order.city_ref': function (val) {
      // this.order.sklad = this.order.sklad_ref = ''
      this.sklad = []
      if (val.length) {
        this.npData('sklad', val)
      }
    },
    'delivery.country': function (val) {
      this.delivery.method = Object.keys(this.countries[val])[0];
    },
    'order.customTTN': function () {
      this.validateForm()
    },
    'delivery.method': function (val) {
      // console.log(val)
      if (val === 'up') {
        this.order.nal_type = 1;
      }
      this.order.post_type = val;
      this.delivery.city_ref = '';
      this.delivery.city = '';
      this.order.city = '';
      this.delivery.sklad = '';
      this.order.sklad = '';
      this.delivery.sklad_ref = '';
      if (val === 'np_address') {
        this.order.city_ref = 'ok';
        this.order.sklad_ref = 'ok';
      } else {
        this.order.city_ref = '';
        this.order.sklad_ref = '';
      }

      // console.log(this.order.city)
      this.delivery.type = this.countries[this.delivery.country][this.delivery.method];
    }
  },
  methods: {
    ...mapActions({
      addProductToCart: 'cart/addProductToCart',
      addFilesToProduct: 'cart/addFilesToProduct',
      cleanCart: 'cart/cleanCart',
      ud: 'cart/updateDisc',
      removeProductFromCart: 'cart/removeProductFromCart',
      decrementItemQuantity: 'cart/decrementItemQuantity'
    }),
    loadUp(value) {
      this.npData('up_city', value)
    },
    changeUser(value) {
      this.order.user_id = value.ref
    },
    usersData() {
      axios.get('users/').then((response) => {
        this.users = response.data.data
      })
    },
    fetchData() {
      if (location.hash == '#products') {
        this.hideProducts = true
        history.replaceState(null, null, ' ');
      }
      if (localStorage.getItem('order')) {
        this.order = JSON.parse(localStorage.getItem('order'));
        this.delivery.city = this.order.city
        this.delivery.city_ref = this.order.city_ref
        this.delivery.sklad = this.order.sklad
        this.delivery.sklad_ref = this.order.sklad_ref
      }
      this.$store.dispatch('products/getAllProducts').then((products) => {

        this.loading = false

        let cart = [];
        let cartProducts = [];

        if (localStorage.getItem('cart_data')) {
          cart = JSON.parse(localStorage.getItem('cart_data'));
          cartProducts = cart.filter(({id}) => {
            id = this.getPid(id)
            const product = products.find(product => product.id === id)
            if (product) {
              return product
            }
          })
        }

        this.$store.dispatch('cart/loadCart', cartProducts)
        this.$store.dispatch('cart/saveCart')
        if (this.delivery.country === '') {
          this.delivery.country = "ukraine";
        }
        this.updateDiscount()
      })
    },
    getPid(id) {
      if (!Number.isInteger(id) && id.includes('_')) {
        return parseInt(id.split('_')[0])
      }
      return id;
    },
    npData(type, ref) {
      // console.log(type, ref)
      let post_type = this.delivery.method;
      let sendData = {
        type, ref, post_type, selectedCity: this.selectedCity
      }
      axios.post('city/', sendData).then((response) => {
            if (type === 'city') {
              this.city = response.data.data
            }
            if (type === 'up_city') {
              this.cityUp = response.data.data
            }
            if (type === 'sklad') {
              this.sklad = response.data.data
            }
            if (type === 'sklad_up') {
              this.sklad = response.data.data
            }
            this.validateForm()
          }
      )
    },
    changeCity(value) {
      this.selectedCity = value
      this.order.city = value.name
      this.order.city_ref = value.ref
      this.delivery.city = value.name
      this.delivery.city_ref = value.ref
    },
    setZip(value) {
      this.order.city = value.region
      this.order.city_ref = '_'
      this.order.skald = value.ref
      this.order.sklad_ref = value.ref
    },
    searchZip(value) {
      this.sklad = []
      this.npData('sklad_up', value)
    },
    changeNP(value) {
      this.order.sklad = value.name
      this.order.sklad_ref = value.ref
      this.delivery.sklad = value.name
      this.delivery.sklad_ref = value.ref
      this.validateForm()
    }
    ,
    createOrder() {
      this.error = {};
      this.errorProducts = {};
      this.hasError = true;
      let sendData = {
        'order': this.order,
        'delivery': this.deliveryCost,
        'deliveryData': this.delivery,
        'cart': this.cart.map((product) => {
          return {
            id: product.id,
            product_id: product.product_id,
            price: product.price,
            count: product.count,
            files: product.files,
            custom: product.custom
          };
        })
      }
      axios.post('create/', sendData).then((response) => {
        if (response.data.data.input) {
          this.error = response.data.data.input
        }
        if (response.data.data.products) {
          this.errorProducts = response.data.data.products
          // this.errorProducts =	response.data.data.products.map(({id, count}) => {
          //     const product = this.products.find(product => product.id === id)
          //     product.stock = count;
          //     return product;
          // })
        }
        if (response.data.success) {
          localStorage.removeItem('order')
          localStorage.removeItem('cart_data')
          this.order.ttn = ''
          this.order.customTTN = false
          this.cleanCart()
          this.$router.replace({
            'name': 'orders'
          })
        }
        this.hasError = false;
      }).catch(() => {
        this.hasError = false;
      })
    }
    ,
    validateInput(event, type) {
      switch (type) {
        case "phone":
          this.order.phone = event.target.value.replace(/\D/g, "") //.substring(0, 12)
          break;
        case "name":
          this.order.name = event.target.value.trim()
          break;
      }

    },
    onTTNUpload(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;

      let form = new FormData();
      form.append("file", files[0]);
      form.append("name", files[0].name);
      axios.post('ttn/upload/', form).then((response) => {
        if (response.data.success) {
          for (const [key, value] of Object.entries(response.data.data.data)) {
            this.order[key] = value;
          }
          this.order.customTTN = response.data.data.data;
        }
      }).finally(() => {
        this.$refs.cTTN.value = null;
      })

    },
    onTTNUploadCart(e, product) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;

      let form = new FormData();


      form.append("file", files[0]);
      form.append("product", JSON.stringify(product));
      form.append("name", files[0].name);
      axios.post('create/upload/', form).then((response) => {
        if (response.data.data.file) {
          let files = JSON.parse(JSON.stringify(product.files));
          files.push(response.data.data.file)
          this.addFilesToProduct({product, files})
        }
      }).finally(() => {
        e.target.value = null;
      })
    },
    showCustomModal() {

    },
    updateDiscount() {
      this.ud(false)
      let sendData = {
        'type': 'discount',
        'cart': this.cart.map((product) => {
          return {id: product.id, price: product.price, count: product.count};
        })
      }
      axios.post('city/', sendData).then((response) => {
        this.discount = parseFloat(response.data.data.discount)
      })
    },
    validateForm() {
      this.error = {};
      if (this.order.customTTN) {
        localStorage.setItem('order', JSON.stringify(this.order))
        this.hasError = false;
        return;
      }


      let tmp = this.order.name.trim().split(' ');
      if (tmp.length < 2 || tmp.length > 3) {
        this.error.name = true;
      }
      this.error.phone = true;
      // if ((this.order.phone.length === 10 && this.order.phone.substring(0, 1) == 0) || (this.order.phone.length === 12 && this.order.phone.substring(0, 3) == 380)) {
      //   delete this.error.phone;
      // }
      if (this.order.phone.length > 8) {
        delete this.error.phone;
      }
      localStorage.setItem('order', JSON.stringify(this.order))
      if (this.order.nal_type == 2 && this.order.nal < 1) {
        this.error.nal = true;
        this.hasError = true;
        return
      }
      // console.log(this.delivery)
      delete this.error.city;
      if (this.order.post_type === 'np_address') {
        this.order.city = this.delivery.city
        this.order.sklad = this.delivery.street + ", " + this.delivery.house
      }
      if (this.order.post_type === 'up') {
        if (this.order.sklad_ref.trim().length !== 5) {
          this.error.sklad = true;
          this.hasError = true;
          return
        }
        delete this.error.city;
        this.hasError = false;
        this.order.sklad = '' + this.order.sklad_ref;
        // this.order.city = '_';
        this.order.city_ref = '_';
      } else {


        if (this.order.city == '' || (this.order.post_type === 'np' && this.order.city_ref == '')) {
          this.error.city = true;
          this.hasError = true;
          return
        }
        if (this.order.post_type === 'np' && (this.order.sklad == '' || this.order.sklad_ref == '')) {
          this.error.sklad = true;
          this.hasError = true;
          return
        }
      }

      this.hasError = true
      let sendData = {
        'type': 'delivery',
        'order': this.order,
        'deliveryData': this.delivery,
        'cart': this.cart.map((product) => {
          return {id: product.id, price: product.price, count: product.count};
        })
      }
      axios.post('city/', sendData).then((response) => {
        this.hasError = (Object.keys(this.error).length > 0);
        this.deliveryCost = (this.order.pay_del == 2) ? parseFloat(response.data.data.delivery) : 0
        this.discount = parseFloat(response.data.data.discount)
      })
      // if (this.order.pay_del == 2) {  } else {
      //    this.deliveryCost = 0
      //    this.discount = 0
      //    this.hasError = (Object.keys(this.error).length > 0);
      //  }
    }

  }
}
</script>

<style>
.customTTNFileWrap {
  border: 2px dashed #7367f0;
}

#customTTNFileInput, .customTTNFileInput {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  z-index: 9;
}

.form-control-position {
    position: absolute;
    top: 2px;
    right: 0;
    z-index: 2;
    display: block;
    width: 2.5rem;
    height: 2.5rem;
    line-height: 2.5rem;
    text-align: center;
}
.clear-input:hover {
  color: #ea5455;
  cursor: pointer;
}
</style>